<template>
  <SchoolsForm :typeEndPoint="'adminSchoolsShow'" :dataParams="this.$route.params" />
</template>
<script>
import SchoolsForm from '@/components/modules/admin/schools/form'
export default {
  name: 'SchoolFormEdit',
  components: {
    SchoolsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/schools/edit.vue